<template>
  <b-btn data-test-path="header-camera-button" @click="takeFoto"
         variant="plm-toolbar-secondary"  style="width: 42px">
    <font-awesome-icon icon="camera" />
  </b-btn>
</template>

<script>
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";

export default {
  name: "CameraButton",

  mounted() {},

  methods: {
    getFile(){
      return this.file;
    },

    takeFoto() {
      let app = {
        init: function () {
          let opts = {
            quality: 100,
            destinationType: Camera.DestinationType.DATA_URL,
            sourceType: Camera.PictureSourceType.CAMERA,
            mediaType: Camera.MediaType.PICTURE,
            encodingType: Camera.EncodingType.JPEG,
            cameraDirection: Camera.Direction.BACK,
            popoverOptions: CameraPopoverOptions,
            targetWidth: 720,
            targetHeight: 1280,
          };

          navigator.camera.getPicture(app.ftw, app.wtf, opts);
        },
        ftw: (dataUrl) => {
          const contentType = 'image/png';
          this.file= this.b64toBlob(dataUrl, contentType);
          this.$emit("push-uploaded-file", this.file);
        },
        wtf: (msg) => {
          console.log("Error " + msg);
        }
      };
      document.addEventListener("deviceready", app.init);
    },

    b64toBlob(b64Data, contentType='', sliceSize=512){
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      const currentDate = new Date();

      const day = String(currentDate.getDate()).padStart(2, '0');
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const year = currentDate.getFullYear();

      const hours = String(currentDate.getHours()).padStart(2, '0');
      const minutes = String(currentDate.getMinutes()).padStart(2, '0');
      const seconds = String(currentDate.getSeconds()).padStart(2, '0');

      const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;

      const blob = new Blob(byteArrays, {type: contentType});
      blob.name = `SilkPLM ${formattedDate}.png`;
      return blob;
    },
  },

  props: {
    listOfImagesInGalleryCard: {default: null},
  },

  data: () => ({
    file: {default: Blob},
  })
}
</script>
